// Проверка аутентификации
export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

// Выход из системы
export const logout = () => {
  localStorage.removeItem('token');
  // Больше не нужно событие, так как мы передаем функцию обновления
};